import { Component, Input, OnInit } from '@angular/core';
import { CoreService } from '../core.service';
import { ControlButton } from '../viewModels/layout.viewModel';

@Component({
    selector: 'opath-core-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    standalone: false
})
export class LayoutComponent implements OnInit {
  @Input()
  get topControlButtons(): ControlButton[] {
    return this.coreService.topControlButtons;
  }
  set topControlButtons(actions: ControlButton[]) {
    this.coreService.topControlButtons = actions;
  }

  @Input()
  get sideControlButtons(): ControlButton[] {
    return this.coreService.sideControlButtons;
  }
  set sideControlButtons(actions: ControlButton[]) {
    this.coreService.sideControlButtons = actions;
  }

  public get hasVisibleSideControlButtons(): boolean {
    return !!this.sideControlButtons?.find((_) => _.visible);
  }

  @Input()
  get showLoader(): boolean {
    return this.coreService.showLoader;
  }
  set showLoader(value: boolean) {
    this.coreService.showLoader = value;
  }

  @Input()
  get loaderText(): string {
    return this.coreService.loaderText;
  }
  set loaderText(value: string) {
    this.coreService.loaderText = value;
  }

  @Input()
  set rtlEnabled(value: boolean) {
    this.coreService.rtlEnabled = value;
  }
  get rtlEnabled(): boolean {
    return this.coreService.rtlEnabled;
  }

  constructor(private coreService: CoreService) {}

  async ngOnInit(): Promise<void> {}
}
